var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('div',{attrs:{"id":"containerPie1"}})]),_c('el-col',{attrs:{"span":8}},[_c('div',{attrs:{"id":"containerPie2"}})]),_c('el-col',{attrs:{"span":8}},[_c('div',{attrs:{"id":"containerPie3"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }